<div class="d-flex flex-column" style="width: 100%; font-size: 0.875rem;">
<div class="text-white fw-bold px-3 py-2 text-center" style="background-color: #1C1E22;">
  <img [src]="getInterventionDetails().imagePath" alt="icon" width="20" height="20" class="me-2" />
  {{ getInterventionDetails().label }}
</div>


    <div class="flex-grow-1 px-3 py-3" style="background-color: #2A2D30; color: #f1f1f1;">

      <div class="d-flex align-items-start mb-3">
        <app-icon [iconName]="ICONS.PENCIL_RULER" class="icon-white me-2" [width]="18" [height]="18"></app-icon>
        <div>
          <div class="text-light">Geometry type:</div>
          <div style="color: #8F8F93;">{{geometryType}}</div>
        </div>
      </div>

      <div class="d-flex align-items-start mb-3">
        <app-icon [iconName]="ICONS.SEEDLING_ICON" class="icon-white me-2" [width]="18" [height]="18"></app-icon>
        <div>
          <div class="text-light">Area:</div>
          <div style="color: #8F8F93;">
            <ng-container *ngIf="areaInKm2 !== null; else noArea">
              {{ areaInKm2 | number:'1.3-3' }} km²
              <span *ngIf="areaInKm2 * 1_000_000 < 1000000"> ({{ (areaInKm2 * 1_000_000) | number:'1.0-0' }} m²)</span>
            </ng-container>
            <ng-template #noArea>N/A</ng-template>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-start mb-3">
        <app-icon [iconName]="ICONS.EARTH_TREE_DENSITY" class="icon-white me-2" [width]="18" [height]="18"></app-icon>
        <div>
          <div class="text-light">Coordinates (Lng, Lat):</div>
          <div style="color: #8F8F93;">{{ centroid?.[0] | number:'1.5-5' }}, {{ centroid?.[1] | number:'1.5-5' }}</div>
        </div>
      </div>

      <!-- <div class="d-flex align-items-start mb-4">
        <app-icon [iconName]="ICONS.EARTH_CARBON_SEQUESTRATION" class="icon-white me-2" [width]="18" [height]="18"></app-icon>
        <div>
          <div class="text-light">Element order:</div>
          <div style="color: #8F8F93;">{{ featureIndex }}{{ featureIndex === 1 ? 'st' : featureIndex === 2 ? 'nd' : featureIndex === 3 ? 'rd' : 'th' }}</div>
        </div>
      </div> -->

      <button *ngIf="isEditing || isNewlyDrawn"  class="btn btn-danger btn-sm w-100" (click)="deleteDraw()">Delete Shape</button>
    </div>
  </div>
